import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SelectedCountry {
  id: number;
  code: string;
  name: string;
  flag_image: string;
  price_per_bit: number;
  currency_name: string;
  currency_sort_name: string | null;
  currency_symbol: string | null;
}

export interface SelectedCountryState {
  country: SelectedCountry | null;
  isLoading: boolean;
}

const initialState: SelectedCountryState = {
  country: {
    id: 0,
    code: "NZ",
    name: "New Zealand",
    flag_image: "images/flags/nz.png",
    price_per_bit: 1,
    currency_name: "Dollar",
    currency_sort_name: null,
    currency_symbol: "$",
  },
  isLoading: false,
};

export const selectedCountrySlice = createSlice({
  name: "selectedCountry",
  initialState,
  reducers: {
    setSelectedCountry: (state, action: PayloadAction<SelectedCountry>) => {
      state.country = action.payload;
      state.isLoading = false;
    },
    setSelectedCountryLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    clearSelectedCountry: () => {
      return initialState;
    },
  },
});

export const {
  setSelectedCountry,
  setSelectedCountryLoading,
  clearSelectedCountry,
} = selectedCountrySlice.actions;

export default selectedCountrySlice.reducer;

